import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
    selector: 'app-loader-overlay',
    templateUrl: './loader-overlay.component.html',
    styleUrls: ['./loader-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoaderOverlayComponent {
    readonly active$: Observable<boolean> = this.loader.active$;

    constructor(private readonly loader: LoaderService) {}
}
